import { Divider, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import FlxGrid from "../../../_src_shared/components/layout/FlxGrid";
import InfoGridItem from "./InfoGridItem";
import InfoRowItem from "./InfoRowItem";
import Flx from "../../layout/Flx";

const InfoGrid = ({
  items,
  width = "350px",
  gap = "24px 22px",
  mb = 4,
  row = false,
  labelUppercase,
  labelFontSize,
  rowDivider = false,
  sx = {},
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  if (row) {
    return (
      <Flx
        // suppressAutoMobile
        fw
        column
        sx={{
          gap,
          mb,
          ...sx,
        }}
      >
        {items.map((item, index) => {
          return (
            <>
              <InfoRowItem
                key={index}
                labelUppercase={labelUppercase}
                label={item.label}
                hideDivider={!rowDivider || index === items?.length - 1}
                labelFontSize={labelFontSize}
                value={item.value}
                fullWidth={item.fullWidth}
              />
            </>
          );
        })}
      </Flx>
    );
  }
  return (
    <FlxGrid
      // suppressAutoMobile
      width={isMobile ? "100px" : width}
      sx={{
        gap,
        mb,
        ...sx,
      }}
    >
      {items.map((item, index) => (
        <InfoGridItem
          key={index}
          label={item.label}
          value={item.value}
          labelFontSize={labelFontSize}
          fullWidth={item.fullWidth}
          labelUppercase={labelUppercase}
        />
      ))}
    </FlxGrid>
  );
};
export default InfoGrid;
